require('./jv.tracking.jobBoards.versionFAC');

angular.module('jv.tracking.jobBoards.commonActionsFAC', [
    'jv.tracking.jobBoards.versionFAC'
    ])
    .factory('commonControllerActionsFAC', ['$location', 'jobBoardVersionsFAC',
        function ($location, jobBoardVersionsFAC) {
            return function(){
                return{
                    validateName: function(name){
                        return name && name.indexOf(' ') < 0;
                    },
                    redirectToList: function(){
                        $location.path('/list');
                    },
                    addNewVersion: function(jobBoardVersions){
                        if(jobBoardVersions){
                            var nextVersion = jobBoardVersionsFAC(jobBoardVersions);
                            if(nextVersion !== -1){
                                jobBoardVersions[nextVersion] = {
                                    add: true,
                                    fileName: '',
                                    sourceParameters: '',
                                    connector:{
                                        params:{}
                                    },
                                    notification:{
                                        toEmails: []
                                    }
                                };
                            }
                        }
                        return jobBoardVersions;
                    }
                };
            };
        }
    ]);